import { render, staticRenderFns } from "./DoNotSendModal.vue?vue&type=template&id=6408602c&scoped=true"
import script from "./DoNotSendModal.vue?vue&type=script&lang=js"
export * from "./DoNotSendModal.vue?vue&type=script&lang=js"
import style0 from "./DoNotSendModal.vue?vue&type=style&index=0&id=6408602c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6408602c",
  null
  
)

export default component.exports